import { HttpHeaders,HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/services';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';

import { environment } from '../../../environments/environment';
import { IUserDetails } from '../../../app/admin/models/user.model';

@Injectable({
  providedIn: 'root'
})
export class CompanyApprovalService {
    constructor(private http: HttpClient,
        private apiService: ApiService) { }
        public getAllCompanyApprovalList(userApprovalSearchParam:IGlobalSearchParam):Observable<any> {
            return this.apiService.post(`CompanyProfile/SearchCompanyApproval`,userApprovalSearchParam)
        }
        public getUserProfileDetails(id:number):Observable<any>{
          return this.apiService.get(`UserProfiles/${id}`);
        }
        public approveCompany(id:number,userDetails:IUserDetails):Observable<any>{
          return this.apiService.put(`UserProfiles/${id}`,userDetails);
        }
        public rejectCompany(companyProfileId:number,loggedInUserId:number):Observable<any>{
          return this.apiService.get(`CompanyProfile/RejectCompany?companyProfileId=${companyProfileId}&loggedInUserId=${loggedInUserId}`);
        }
        public needInformation(companyProfileId:number,loggedInUserId:number):Observable<any>{
          return this.apiService.get(`CompanyProfile/NeedInformationCompany?companyProfileId=${companyProfileId}&loggedInUserId=${loggedInUserId}`);
        }
        public inReviewCompany(companyProfileId:number,loggedInUserId:number):Observable<any>{
          return this.apiService.get(`CompanyProfile/InReviewCompany?companyProfileId=${companyProfileId}&loggedInUserId=${loggedInUserId}`,);
        }
        public viewCompanyProfile(profileId:number):Observable<any>{
          return this.apiService.get(`UserProfiles/RegisteredUserViewProfile/${profileId}`);
        }
        
        public updateVendorClientAssignment(companyId:number,userId): Observable<any> {
          return this.apiService.get(`CompanyProfile/UpdateVendorClientAssignment?companyId=${companyId}&userId=${userId}`);
         }
         public updatePaymentTerms(companyId:number,paymentTermsId:number): Observable<any> {
          return this.apiService.get(`CompanyProfile/UpdatePaymentTerms?companyId=${companyId}&paymentTermsId=${paymentTermsId}`);
         }
         public getVendorProfileStatusList(vendorProfileSearchParam:IGlobalSearchParam):Observable<any> {
          return this.apiService.post(`CompanyProfile/SearchCompanyProfileCompleteStatus`,vendorProfileSearchParam)
      }
      public ExportVendorProfileStatusResult(vendorProfileSearchParam:IGlobalSearchParam):Observable<any> {
        return this.http.post(`${environment.apiRoot}CompanyProfile/ExportCompanyProfileCompleteStatus`, vendorProfileSearchParam,
        {  
            responseType: 'blob',
            observe: 'response'
         });
      }
    
}